module.exports = __webpack_public_path__ + "img/recharge_tips.d64f5411.png";